<template>
  <div class="vuse-content-wrapper contact-app">
    <vuse-section-definition
      :title="page"
      icon="view_list"
      v-show="!hideTitle"
    />
    <v-container fluid class="">
      <v-row>
        <v-col cols="12" lg="6" md="6" sm="8"
          ><v-text-field
            v-model="filter.SearchTerm"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            solo
          ></v-text-field
        ></v-col>

        <v-col cols="12" lg="6" md="6" sm="4" class="text-right">
          <v-btn
            color="info"
            dark
            class="mb-2"
            @click="onNew()"
            v-show="hasAccess('item.add')"
          >
            Add Item Purchase
          </v-btn>
        </v-col>
      </v-row>
      <template>
        <v-card>
          <v-skeleton-loader
            v-if="isLoading"
            class="mx-auto"
            type="table"
          ></v-skeleton-loader>
          <v-data-table
            :headers="activeHeaders"
            :items="dataItems"
            :options.sync="tableOptions"
            :server-items-length="totalItems"
            class="elevation-1"
            :loading="loading"
            @click:row="onEdit"
            :footer-props="{
              'items-per-page-options': [10, 20, 30, 40, 50, 100, 200],
            }"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-menu offset-y :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <v-btn rounded class="content-ma-0 mr-2" v-on="on" x-small>
                      <v-icon small>menu</v-icon> Customize Columns
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item dense :key="i" v-for="(header, i) in headers">
                      <v-list-item-title v-if="header.readonly">
                        <v-checkbox
                          v-model="headers[i].active"
                          :label="header.text"
                          :disabled="true"
                        />
                      </v-list-item-title>
                      <v-list-item-title v-else>
                        <v-checkbox
                          v-model="headers[i].active"
                          :label="header.text"
                        />
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-toolbar>
            </template>
            <template v-slot:item.lastUpdated="{ item }">
              <v-chip @click="onEdit(item)" small>
                {{ item.lastUpdated | formatDatetime }}
              </v-chip>
            </template>

            <template v-slot:item.price="{ item }">
              {{ item.price | formatPrice }}
            </template>

            <template v-slot:item.isInvoiced="{ item }">
              {{ item.isInvoiced ? `Yes` : `No` }}
            </template>

            <template v-slot:item.date="{ item }">
              <v-chip small>{{ item.date | formatDate }}</v-chip>
            </template>

            <template v-slot:item.cost="{ item }">
              {{ item.cost | formatPrice }}
            </template>

            <template v-slot:item.actions="{ item }">
              <v-btn-toggle borderless background-color="transparent">
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn icon small class="content-ma-0" v-on="on">
                      <v-icon small>mdi-cogs</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      @click="onEdit(item)"
                      v-show="hasAccess('item.edit')"
                    >
                      <v-list-item-title>
                        <v-icon small left>mdi-pencil</v-icon>Edit
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      @click="onDelete(item)"
                      v-show="hasAccess('item.delete')"
                    >
                      <v-list-item-title>
                        <v-icon small left>delete</v-icon>Delete
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-btn                  
                  small
                  class="content-ma-0"
                  v-if="item.invoiceId"
                  @click="goToInvoice(item)"
                >
                  #{{ item.invoiceId }}
                </v-btn>

                <v-btn
                  small
                  class="content-ma-0"
                  v-if="item.quoteId"
                  @click="goToQuote(item)"
                >
                  #{{ item.quoteId }}
                </v-btn>                
              </v-btn-toggle>
            </template>
            <template v-slot:no-data>
              <span v-text="noRecordFound"></span>
            </template>
          </v-data-table>
        </v-card>
      </template>
    </v-container>

    <add-form
      :item="selectedItem"
      :show="showEdit"
      @onClosed="clearEdit()"
      @onSucceded="refresh()"
      :client-id="clientId"
    />
    <delete-dialog
      :item="selectedItem"
      :show="showDelete"
      @onSucceded="refresh()"
      @onClosed="clearDelete()"
    />
    <detail
      :item="selectedItem"
      :show="showDetail"
      @onSucceded="refresh()"
      @onClosed="clearDetail()"
    />
  </div>
</template>
<script>
import AddForm from "./ItemPurchase/_Form";
import DeleteDialog from "./ItemPurchase/_Delete";
import Detail from "./ItemPurchase/_Detail";
import { mapState, mapActions, mapGetters } from "vuex";
import formatterMixin from "@/mixins/formatterMixin";
import { getStorage, setStorage } from "src/utils/helpers";
import _ from "lodash";

const SETTING_LIST_KEY = "itemPurchase-columns";
const defaultHeaders = [
  {
    text: "Action",
    value: "actions",
    sortable: false,
    readonly: true,
    active: true,
    width: "10%",
  },
  {
    text: "Item Name",
    align: "start",
    sortable: true,
    value: "title",
    active: true,
  },
  {
    text: "Invoiced",
    sortable: true,
    value: "isInvoiced",
    active: true,
  },
  {
    text: "Qty",
    sortable: true,
    value: "quantity",
    active: true,
  },
  {
    text: "Cost",
    sortable: true,
    value: "cost",
    active: true,
  },
  {
    text: "Price",
    sortable: true,
    value: "price",
    active: true,
  },
  {
    text: "Date",
    sortable: true,
    value: "date",
    active: true,
  },
  {
    text: "Date Modified",
    value: "lastUpdated",
    sortable: true,
    active: false,
  },
];
export default {
  props: {
    hideTitle: Boolean,
    clientId: Number,
  },
  mixins: [formatterMixin],
  components: {
    AddForm,
    DeleteDialog,
    Detail,
  },
  data() {
    return {
      namespace: "Applications",
      page: "Item List",

      filter: {
        SearchTerm: "",
        clientId: "",
        status: "",
        isInvoiced: "",
      },

      tableOptions: {},

      showChangePassword: false,
      showDetail: false,
      showEdit: false,
      showDelete: false,
      selectedItem: "",

      noRecordFound: "No record found",

      clients: [],
      headers: defaultHeaders.map((item) => {
        let savedHeaders = getStorage(SETTING_LIST_KEY) || [];
        let nowHeader = savedHeaders.filter(
          (saved) => saved.value === item.value
        );

        if (nowHeader) {
          nowHeader = nowHeader[0];
        }
        return {
          ...item,
          ...nowHeader,
        };
      }),
    };
  },

  async created() {
    await this.refresh();
  },

  watch: {
    headers: {
      handler() {
        setStorage("timeClock-columns", this.headers);
      },
      deep: true,
    },
    tableOptions: {
      async handler(n, o) {
        if (JSON.stringify(n) !== JSON.stringify(o)) {
          await this.refresh();
        }
      },
      deep: true,
    },
    filter: {
      async handler() {
        await this.refresh();
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions("itemPurchase", ["applyTableFilter", "clearTableFilter"]),

    goToInvoice(item) {
      this.$router.push(`/invoices/${item.invoiceId}/edit`);
    },

    goToQuote(item) {
      this.$router.push(`/bids/${item.quoteId}/edit`);
    },

    onDelete(item) {
      this.selectedItem = item;
      this.showDelete = true;
    },
    onNew() {
      this.selectedItem = {};
      this.showEdit = true;
    },
    onEdit(item) {
      if (!this.hasAccess("item.edit")) {
        return false;
      }
      this.selectedItem = item;
      this.showEdit = true;
    },
    onDetail(item) {
      this.selectedItem = item;
      this.showDetail = true;
    },
    clearDetail() {
      this.selectedItem = "";
      this.showDetail = false;
    },
    clearEdit() {
      this.selectedItem = "";
      this.showEdit = false;
    },
    clearDelete() {
      this.selectedItem = "";
      this.showDelete = false;
    },
    refresh: _.debounce(async function () {
      this.applyTableFilter(this.computedFilter);
    }, 500),
  },

  computed: {
    ...mapGetters("account", ["hasAccess"]),
    ...mapState({
      item: (state) => state.item,
      loading: (state) => state.itemPurchase.loadingTable,
      account: (state) => state.account,
      alert: (state) => state.alert,
      totalItems: (state) => state.itemPurchase.metaData.totalEntries,
    }),

    isLoading() {
      return this.loading && this.dataItems.length == 0;
    },

    computedFilter() {
      const { clientId, isInvoiced, SearchTerm } = this.filter;
      let { sortBy, sortDesc, page, itemsPerPage } = this.tableOptions;
      let params = {
        PageNumber: page ? page : 1,
        PageSize: itemsPerPage > 0 ? itemsPerPage : 10,
      };
      params.OrderBy =
        sortBy.length > 0 && sortBy[0] ? sortBy[0] : "dateCreated";
      params.Ascending =
        typeof sortDesc[0] !== "undefined" ? sortDesc[0] : false;

      if (clientId) {
        params.clientId = clientId;
      }

      if (this.clientId) {
        params.clientId = this.clientId;
      }

      if (isInvoiced) {
        params.isInvoiced = isInvoiced;
      }

      if (SearchTerm) {
        params.SearchTerm = SearchTerm;
      }
      return params;
    },

    activeHeaders() {
      return this.headers.filter((header) => header.active);
    },

    dataItems() {
      let items = this.$store.getters["itemPurchase/getAll"];
      return items.filter((item) => item.clientId === this.clientId);
    },
  },

  beforeDestroy() {
    this.$store.dispatch("itemPurchase/clearData");
  },
};
</script>